import { Button, DatePicker, Drawer, Form, Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { DropdownIconNew } from '../../theme/SvgIcons';
import { leadPlateform } from '../../utils/constant';
import { ButtonWrapper, FieldBox } from '../../theme/common_style';
import styled from '@emotion/styled';
import useGetBusinessEmp from '../../hooks/useGetBusinessEmp';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const LeadFilters = ({ open, onClose, setPage, appliedFilter, setAppliedFilter }) => {
  const [form] = Form.useForm();
  const { loading: businessEmpLoading, options: businessEmpList } = useGetBusinessEmp();

  const onSubmit = (values) => {
    const formattedValues = {
      ...values
    };
    setAppliedFilter(formattedValues);
    setPage(1);
    onClose();
  };

  const onReset = () => {
    form.resetFields();
    setAppliedFilter(null);
    setPage(1);
    onClose();
  };

  useEffect(() => {
    if (appliedFilter) {
      form.setFieldsValue({
        ...appliedFilter
      });
    }
  }, [appliedFilter]);

  return (
    <Drawer
      width={390}
      title="Filters"
      placement="right"
      closable={true}
      prefixCls="activityCustomDrawer"
      onClose={onClose}
      open={open}
      key="right">
      <ContainerStyle>
        <Form style={{ height: '100%' }} form={form} onFinish={onSubmit}>
          {() => (
            <div className="filter-flex">
              <div>
                <FieldBox>
                  <label>Owner</label>
                  <Form.Item name="ownerId">
                    <Select
                      prefixCls="form-select"
                      allowClear
                      suffixIcon={<DropdownIconNew />}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      loading={businessEmpLoading}
                      placeholder="--Select Option--"
                      options={businessEmpList}
                    />
                  </Form.Item>
                </FieldBox>
                <FieldBox>
                  <label>Platform</label>
                  <Form.Item name="platform">
                    <Select
                      mode="multiple"
                      maxTagCount={1}
                      prefixCls="antMultipleSelector"
                      showSearch
                      allowClear
                      suffixIcon={<DropdownIconNew />}
                      filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      placeholder="Platform"
                      options={leadPlateform}
                    />
                  </Form.Item>
                </FieldBox>
                <FieldBox>
                  <label>Date Range</label>
                  <Form.Item name="date">
                    <RangePicker
                      style={{
                        width: '100%',
                        boxShadow: 'none',
                        outline: 'none',
                        height: '56px',
                        borderRadius: '8px',
                        textAlign: 'center !important'
                      }}
                      presets={[
                        {
                          label: 'Today',
                          value: [dayjs(), dayjs()]
                        },
                        {
                          label: 'Yesterday',
                          value: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')]
                        },
                        { label: 'Last 7 Days', value: [dayjs().subtract(7, 'day'), dayjs()] },
                        { label: 'Last 14 Days', value: [dayjs().subtract(14, 'day'), dayjs()] },
                        { label: 'Last 30 Days', value: [dayjs().subtract(30, 'day'), dayjs()] },
                        { label: 'Last 60 Days', value: [dayjs().subtract(60, 'day'), dayjs()] },
                        { label: 'Last 90 Days', value: [dayjs().subtract(90, 'day'), dayjs()] }
                      ]}
                    />
                  </Form.Item>
                </FieldBox>
              </div>

              <div style={{ paddingBottom: '20px' }}>
                <ButtonWrapper>
                  <button className="reset" onClick={onReset}>
                    Reset
                  </button>
                  <Button prefixCls="antCustomBtn" style={{ width: '100%' }} htmlType="submit">
                    Apply
                  </Button>
                </ButtonWrapper>
              </div>
            </div>
          )}
        </Form>
      </ContainerStyle>
    </Drawer>
  );
};

export default LeadFilters;

LeadFilters.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  setPage: PropTypes.func,
  appliedFilter: PropTypes.object,
  setAppliedFilter: PropTypes.func
};

const ContainerStyle = styled.div`
  width: 100%;
  padding: 10px 25px;
  height: 100%;

  .filter-flex {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    margin-bottom: 20px;
  }
  /* Default styling for desktop */
  .ant-picker-range {
    width: 100%;
  }

  /* Mobile responsive adjustments */
  @media (max-width: 600px) {
    .ant-picker-range {
      font-size: 14px;
      height: 48px;
    }

    .ant-picker-dropdown {
      width: 100% !important;
      left: 0 !important;
    }

    .ant-picker-panels {
      flex-direction: column !important;
    }
  }
`;
